import { Client, Databases, ID, Query } from 'appwrite';

// Initialize Appwrite client
const client = new Client()
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT || '')
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID || '');

export const databases = new Databases(client);

// Export client for ping verification
export { client };

// Database and Collection IDs
export const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID || '';
export const USERS_COLLECTION_ID = process.env.REACT_APP_APPWRITE_USERS_COLLECTION_ID || '';
export const EVENTS_COLLECTION_ID = process.env.REACT_APP_APPWRITE_EVENTS_COLLECTION_ID || '';

// Export Query for use in components
export { Query, ID };

// Type definitions
export type User = {
  id: string;
  username: string;
  role: 'admin' | 'user' | 'superadmin';
  is_blocked: boolean;
  is_logged_in: string;
  last_logout_tab: string;
  name: string;
  jamiaat: string;
  password: string;
  created_at: string;
  last_active?: string;
  tag?: string;
};

export type Event = {
  id: string;
  name: string;
  youtube_link: string;
  is_active: boolean;
  created_at: string;
};
